import { Item } from '@react-stately/collections'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ArrowRefresh2, LinkAngled, MoreDots, TextInput, Trash2, ArrowExpandThree } from 'blaze-ui/icons'
import { Menu } from 'components/Menu/Menu'
import { Key } from 'react'
import { openImageReplacePrompt } from '../../openImageReplacePrompt'
import { EditorView } from 'prosemirror-view'
import { schema } from 'prose-core'
import { ImageNodeAttrs } from '../../Types'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Unsplash } from 'proseShared/IntegrationsIcons'
import { useModals } from 'almanac-ui/Modal'

interface Props {
  view: EditorView<typeof schema>
  attrs: ImageNodeAttrs
  onAction?: (key: Key) => void
}

export const MoreButton = ({ view, attrs, onAction }: Props) => {
  const stackManager = useModals()
  const handleAction = (key: Key) => {
    if (key === 'replace') {
      openImageReplacePrompt(view, attrs, {
        initialQuery: attrs.unsplashQuery || '',
        preselectedIntegration: Unsplash,
        stackManager,
      })
      return
    }

    if (key === 'delete') {
      // Handled by the parent
    }

    if (key === 'link') {
      // Handled by the parent
    }

    if (key === 'caption') {
      // Handled by the parent
    }

    if (key === 'zoom') {
      // Handled by the parent
    }

    onAction?.(key)
  }

  const link = attrs.href

  return (
    <MenuTrigger>
      <IconButton variant="editor" icon={MoreDots} size="sm" preventFocusOnPress aria-label="More actions" />
      <Menu onAction={handleAction}>
        <Item key="replace" textValue="Change Image">
          <ArrowRefresh2 /> Change Image
        </Item>
        <Item key="caption" textValue="Add Caption">
          <TextInput /> Add Caption
        </Item>
        <Item key="link" textValue={link ? 'Remove Link' : 'Add Link'}>
          <LinkAngled /> {link ? 'Remove Link' : 'Add Link'}
        </Item>
        <Item key="zoom" textValue="View in Full Size">
          <ArrowExpandThree /> View in Full Size
        </Item>
        <Item key="delete" textValue="Delete Image">
          <Trash2 /> Delete Image
        </Item>
      </Menu>
    </MenuTrigger>
  )
}
